import React, { FC, useState } from 'react'
import './AddUser.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import employeeService from 'Services/employeeService'

interface propsType {
  toggleModal: () => void
}

export type addEmployeeFormType = {
  firstName: string
  lastName: string
  gender: string
  msisdn: string
  emailAddress: string
  employmentDate: string
  // personalEmailAddress: string;
}

const phoneRegex = /^\+234\d{10}$/
const phoneMessage = 'Phone number must be in the format +2348194033342'
const nameRegex = /^[A-Za-z\s'-]+$/
const nameMessage = 'Only letters, spaces, apostrophes, and hyphens are allowed'

const schema = yup.object().shape({
  firstName: yup
    .string()
    .required('FirstName field is required')
    .matches(nameRegex, nameMessage)
    .max(50, 'Maximum of 50 characters'),
  lastName: yup
    .string()
    .required('LastName field is required')
    .matches(nameRegex, nameMessage)
    .max(50, 'Maximum of 50 characters'),
  gender: yup.string().required('Gender field is required'),
  msisdn: yup.string().required('Phone number field is required').matches(phoneRegex, phoneMessage),
  emailAddress: yup
    .string()
    .required('Email address field is required')
    .email('Please provide a valid email address'),
  employmentDate: yup.string().required('Employment start date is required'),
  // personalEmailAddress: yup
  //   .string()
  //   .required("Personal Email address field is required"),
})

const AddUser: FC<propsType> = ({ toggleModal }) => {
  const {
    handleSubmit,
    register,
    formState: { errors, isValid, isSubmitting },
  } = useForm<addEmployeeFormType>({
    resolver: yupResolver(schema),
    mode: 'onChange',
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  const submitNewUserInformation = handleSubmit(async (data: addEmployeeFormType) => {
    setRequest(true)
    await employeeService.createNew(data).then(
      () => {
        setRequest(false)
        toggleModal()

        showAlert({
          message: 'Employee added successfully',
          show: true,
          title: 'Success',
          type: 'success',
        })

        setTimeout(() => {
          window.location.reload()
        }, 200)
      },
      (error: { response: { data: { error: string } } }) => {
        setRequest(false)
        toggleModal()
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })
      },
    )
  })
  return (
    <div className='AddUser'>
      <form action='/product-scanner'>
        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>First Name</label>
          <input
            type='text'
            id='newCustomerFirstName'
            className='form-control'
            {...register('firstName')}
          />
          {errors.firstName && <div className='text-danger'>{errors.firstName.message}</div>}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>Last Name</label>
          <input
            type='text'
            id='newCustomerLastName'
            className='form-control'
            {...register('lastName')}
          />
          {errors.lastName && <div className='text-danger'>{errors.lastName.message}</div>}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='gender'>Gender</label>
          <select id='gender' defaultValue='' className='form-control' {...register('gender')}>
            <option disabled value=''>
              --Select gender--
            </option>
            <option value='M'>Male</option>
            <option value='F'>Female</option>
          </select>
          {errors.gender && <div className='text-danger'>{errors.gender.message}</div>}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>Msisdn </label>
          <input
            type='text'
            id='newCustomerMsisdn'
            className='form-control'
            {...register('msisdn')}
            placeholder='+2348194033342'
          />
          {errors.msisdn && <div className='text-danger'>{errors.msisdn.message}</div>}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>Official Email</label>
          <input
            type='text'
            id='newCustomerEmailAddress'
            className='form-control'
            {...register('emailAddress')}
          />
          {errors.emailAddress && <div className='text-danger'>{errors.emailAddress.message}</div>}
        </div>
        <div className='form-group mb-3'>
          <label htmlFor='employmentDate'>Start Date</label>
          <input
            type='date'
            id='employmentDate'
            className='form-control'
            {...register('employmentDate')}
          />
          {errors.employmentDate && (
            <div className='text-danger'>{errors.employmentDate.message}</div>
          )}
        </div>
        {/* <div className="form-group mb-3">
          <label htmlFor="personalEmailAddress">Personal Email Address</label>
          <input
            type="text"
            id="personalEmailAddress"
            className="form-control"
            {...register("personalEmailAddress")}
          />
          {errors.personalEmailAddress && (
            <div className="text-danger">
              {errors.personalEmailAddress.message}
            </div>
          )}
        </div> */}
        <div className='form-group mb-3'>
          <button
            className='btn btn-default w-100'
            onClick={(e) => submitNewUserInformation(e)}
            disabled={!isValid || isSubmitting || request}
          >
            Add User {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default AddUser
